<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <v-card>
      <v-card-title class="pb-0 text-primary">
        <span class="headline">New Varaint</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" style="min-height: 50vh">
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Label*"
                  :rules="rules.required"
                  required
                  v-model="Variant.name"
                ></v-text-field>

                <v-select
                  v-model="Variant.display"
                  :items="['select', 'radio']"
                  label="Display"
                  small
                  :rules="rules.required"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 d-flex align-content-space-between
                ><h4>Values</h4>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn
                  dense
                  small
                  outline
                  style="width: 30px"
                  color="primary"
                  @click="addValue()"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </v-flex>
              <template v-for="(v, index) in Variant.values">
                <v-flex xs4 :key="index + 'a'">
                  <v-text-field
                    label="name*"
                    :rules="rules.required"
                    required
                    v-model="v.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 :key="index + 'b'">
                  <v-text-field
                    label="Price*"
                    :rules="rules.price"
                    type="number"
                    required
                    v-model.number="v.price"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 :key="index + 'b'">
                  <v-text-field
                    label="Weight (gms)"
                    :rules="rules.price"
                    type="number"
                    required
                    v-model.number="v.weight"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 :key="index + 'c'">
                  <v-btn round fab small color="red" @click="removeValue(index)"
                    ><v-icon>mdi-minus</v-icon></v-btn
                  >
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" small outline @click.native="cancel()"
          >Cancel</v-btn
        >
        <v-btn
          color="primary darken-1 white--text"
          small
          :disabled="!valid"
          @click.native="addVariant()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    variant: { type: Object },
    value: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
  },
  watch: {
    value(value) {
      if (value) this.Variant = this.edit ? this.variant : this.newVariant();
    },
  },
  data() {
    return {
      valid: false,
      Variant: this.edit ? this.variant : this.newVariant(),
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'This field Cannot be empty.'],
        price: [v => /^\d+(,\d{1,2})?$/.test(v) || 'Enter valid price'],
        discount: [
          v => (/^\d+(,\d{1,2})?$/.test(v) && v <= 100) || 'Enter valid value',
        ],
      },
    };
  },
  methods: {
    addVariant() {
      this.$emit('addVariant', this.Variant);
      this.resetForm();
    },
    resetForm() {
      this.newVariant();
    },
    newVariant() {
      return {
        name: '',
        display: 'select',
        values: [this.newValue()],
      };
    },
    newValue() {
      return {
        name: '',
        value: '',
        price: 0,
        weight: 0,
      };
    },
    addValue() {
      this.Variant.values.push(this.newValue());
    },
    removeValue(i) {
      this.Variant.values.splice(i, 1);
    },
    cancel() {
      this.$emit('cancel');
      this.resetForm();
    },
  },
};
</script>
